import { useCallback, useEffect, useSyncExternalStore } from "react";

import type {
  AnnotationRenderSourceRef,
  AnnotationStudioController,
  TrackingFrameRenderResource,
} from "./types";

export function useTrackingFrameRenderResource(
  controller: AnnotationStudioController,
  ref: AnnotationRenderSourceRef | null,
): TrackingFrameRenderResource | null {
  const refId = ref?.id ?? null;
  const refRevision = ref?.revision ?? null;

  // ref 전환마다 cleanup으로 release(null)를 끼우면 컨트롤러의 acquire-후-release 유지가
  // 무효화된다(프레임마다 해제→재획득 왕복). 해제는 unmount/controller 교체에서만 한다.
  useEffect(() => {
    if (refId === null || refRevision === null) return;
    controller.prepareTrackingFrameRenderResource?.({ id: refId, revision: refRevision });
  }, [controller, refId, refRevision]);

  useEffect(() => () => controller.prepareTrackingFrameRenderResource?.(null), [controller]);

  const getSnapshot = useCallback(
    () =>
      refId === null || refRevision === null
        ? null
        : controller.getTrackingFrameRenderResource({ id: refId, revision: refRevision }),
    [controller, refId, refRevision],
  );

  return useSyncExternalStore(
    controller.subscribeTrackingFrameRenderResource,
    getSnapshot,
    getSnapshot,
  );
}
